(function () {
  if (window.__saInit) return;
  window.__saInit = true;

  var lastVariantId = null;
  var POLL_MS = 350;

  function currentVariantId() {
    var el = document.querySelector('.sa-widget');
    var fromWidget = el && el.dataset.variantId;

    var select = document.querySelector('select[name="id"]');
    if (select && select.value) return select.value;

    var input = document.querySelector('input[name="id"]');
    if (input && input.value) return input.value;

    return fromWidget || null;
  }

  function swapWidget(variantId) {
    if (!variantId) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    root = root.replace(/\/$/, '');
    var url = root + '/variants/' + variantId + '/?section_id=store-availability';

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshWidget = doc.querySelector('.sa-widget');
        if (!freshWidget) return;
        document.querySelectorAll('.sa-widget').forEach(function (existing) {
          existing.replaceWith(freshWidget.cloneNode(true));
        });
      })
      .catch(function (err) {
        console.warn('Store availability refresh failed', err);
      });
  }

  function tick() {
    var id = currentVariantId();
    if (id && id !== lastVariantId) {
      lastVariantId = id;
      swapWidget(id);
    }
  }

  function start() {
    var widget = document.querySelector('.sa-widget');
    if (widget) lastVariantId = widget.dataset.variantId || null;
    setInterval(tick, POLL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
